<template>
  <q-page class="q-pa-md bg-grey-2">
    <!-- NAVEGACIÓN Y BREADCRUMBS -->
    <div class="row items-center justify-between q-mb-md">
      <q-breadcrumbs active-color="primary" style="font-size: 14px">
        <q-breadcrumbs-el label="Inicio" icon="home" to="/aveo/Dashboard" />
        <q-breadcrumbs-el label="Servicios" icon="build" />
        <q-breadcrumbs-el label="Listado General" icon="list" />
      </q-breadcrumbs>

      <div class="row q-gutter-sm">
        <q-btn
          color="primary"
          icon="add"
          label="Nuevo Servicio"
          no-caps
          unelevated
          class="text-weight-bold"
          @click="AbrirNuevoServicio"
        />
      </div>
    </div>

    <!-- Banner Principal -->
    <q-card class="q-mb-md shadow-2 rounded-borders overflow-hidden">
      <div class="bg-primary text-white q-pa-md row items-center justify-between">
        <div class="row items-center">
          <q-icon name="build" size="md" class="q-mr-sm" />
          <div>
            <div class="text-h6 text-weight-bold">Gestión Global de Servicios</div>
            <div class="text-caption text-blue-2">Mantenimiento de catálogo de servicios del sistema</div>
          </div>
        </div>
      </div>

      <!-- Filtro de Búsqueda -->
      <q-card-section class="q-pa-md">
        <div class="row q-col-gutter-md items-center">
          <div class="col-12 col-sm-9 col-md-10">
            <q-input
              v-model="buscar"
              outlined
              dense
              placeholder="Buscar por descripción o alias..."
              clearable
            >
              <template v-slot:prepend>
                <q-icon name="search" />
              </template>
            </q-input>
          </div>
          <div class="col-12 col-sm-3 col-md-2">
            <q-btn
              color="primary"
              icon="search"
              label="Buscar"
              no-caps
              class="full-width text-weight-bold"
              unelevated
            />
          </div>
        </div>
      </q-card-section>
    </q-card>

    <!-- Tabla Quasar -->
    <q-card class="shadow-2 rounded-borders">
      <q-table
        :data="listaFiltrada"
        :columns="columns"
        row-key="idServicio"
        :grid="$q.screen.xs"
        flat
        bordered
        no-data-label="No hay servicios registrados"
      >
        <template v-slot:body-cell-estado="props">
          <q-td :props="props" class="text-center">
            <q-chip
              dense
              text-color="white"
              :color="props.value === 'V' ? 'positive' : 'negative'"
              class="text-weight-bold"
            >
              {{ props.value === 'V' ? 'Vigente' : 'Anulado' }}
            </q-chip>
          </q-td>
        </template>

        <template v-slot:body-cell-obligatorio="props">
          <q-td :props="props" class="text-center">
            <q-badge :color="props.value === 'SI' ? 'primary' : 'grey-6'" class="text-weight-bold">
              {{ props.value || 'NO' }}
            </q-badge>
          </q-td>
        </template>

        <template v-slot:body-cell-actions="props">
          <q-td :props="props" class="text-right">
            <q-btn
              flat
              round
              dense
              color="primary"
              icon="edit"
              @click="EditarServicio(props.row)"
            >
              <q-tooltip>Editar Servicio</q-tooltip>
            </q-btn>
          </q-td>
        </template>
      </q-table>
    </q-card>

    <!-- Modal Crear / Editar Servicio -->
    <servicio-nuevo-modal
      :DialogServicio="dialogModal"
      :Servicio="servicioSeleccionado"
      :Nuevo="esNuevo"
      @CerrarModal="dialogModal = false"
      @GuardadoExitoso="Listar"
    />
  </q-page>
</template>

<script>
import axios from "axios";
import ServicioNuevoModal from "@/pages/Servicio/ServicioNuevo.vue";

export default {
  name: "ServicioListaPage",
  components: { ServicioNuevoModal },
  data() {
    return {
      buscar: "",
      dialogModal: false,
      esNuevo: true,
      servicioSeleccionado: null,
      ListaArticulos: [],
      columns: [
        { name: "idServicio", label: "ID", field: "idServicio", align: "left", sortable: true },
        { name: "descripcion", label: "Descripción", field: "descripcion", align: "left", sortable: true },
        { name: "alias", label: "Alias / Grupo", field: row => row.alias || "-", align: "left" },
        { name: "diasaviso", label: "Días Aviso", field: row => row.diasaviso || 5, align: "center" },
        { name: "obligatorio", label: "Obligatorio", field: "obligatorio", align: "center" },
        { name: "estado", label: "Estado", field: "estado", align: "center" },
        { name: "actions", label: "Acciones", field: "actions", align: "right" },
      ],
    };
  },
  computed: {
    listaFiltrada() {
      if (!this.buscar) return this.ListaArticulos;
      const term = this.buscar.toLowerCase();
      return this.ListaArticulos.filter(
        (item) =>
          (item.descripcion && item.descripcion.toLowerCase().includes(term)) ||
          (item.alias && item.alias.toLowerCase().includes(term)) ||
          (item.idServicio && String(item.idServicio).includes(term))
      );
    },
  },
  created() {
    this.Listar();
  },
  methods: {
    AbrirNuevoServicio() {
      this.servicioSeleccionado = null;
      this.esNuevo = true;
      this.dialogModal = true;
    },
    EditarServicio(row) {
      this.servicioSeleccionado = { ...row };
      this.esNuevo = false;
      this.dialogModal = true;
    },
    Listar() {
      let me = this;
      axios
        .post("ApiWeb/ServicioLista.php", {
          Buscar1: "",
          Pagina: 1,
          TPagina: 50,
        })
        .then(function(response) {
          me.ListaArticulos = response.data.data || [];
        })
        .catch(function(error) {
          console.error("Error al listar servicios:", error);
        });
    },
  },
};
</script>
